"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsLanguageURLs = exports.getCanonicalURLsPageProp = exports.getPagePropsLanguageURLs = exports.addLanguageURLsProps = exports.createCanonicalURLsProps = exports.createLanguageURLsProps = exports.PAGE_TYPE_HOME = exports.PAGE_TYPE_404 = exports.CANONICAL_URLS_PROP = exports.LANG_URLS_PROP = void 0;
const omitBy_1 = __importDefault(require("lodash/fp/omitBy"));
const get_1 = __importDefault(require("lodash/get"));
exports.LANG_URLS_PROP = `_lu`;
exports.CANONICAL_URLS_PROP = `_culs`;
exports.PAGE_TYPE_404 = `PAGE_404`;
exports.PAGE_TYPE_HOME = `HOME`;
const omitPage404Links = (0, omitBy_1.default)(link => link.targetPageType === exports.PAGE_TYPE_404);
function createLanguageURLsProps(langUrls) {
    return {
        [exports.LANG_URLS_PROP]: omitPage404Links(langUrls),
    };
}
exports.createLanguageURLsProps = createLanguageURLsProps;
function createCanonicalURLsProps(langUrls) {
    return {
        [exports.CANONICAL_URLS_PROP]: omitPage404Links(langUrls),
    };
}
exports.createCanonicalURLsProps = createCanonicalURLsProps;
function addLanguageURLsProps(pageProps, langUrls) {
    return Object.assign(Object.assign({}, pageProps), createLanguageURLsProps(langUrls));
}
exports.addLanguageURLsProps = addLanguageURLsProps;
function getPagePropsLanguageURLs(pageProps) {
    return (0, get_1.default)(pageProps, [`props`, exports.LANG_URLS_PROP], (0, get_1.default)(pageProps, [exports.LANG_URLS_PROP], null));
}
exports.getPagePropsLanguageURLs = getPagePropsLanguageURLs;
function getCanonicalURLsPageProp(pageProps) {
    return (0, get_1.default)(pageProps, [`props`, exports.CANONICAL_URLS_PROP], (0, get_1.default)(pageProps, [exports.CANONICAL_URLS_PROP], null));
}
exports.getCanonicalURLsPageProp = getCanonicalURLsPageProp;
function usePagePropsLanguageURLs(pageProps) {
    return getPagePropsLanguageURLs(pageProps);
}
exports.usePagePropsLanguageURLs = usePagePropsLanguageURLs;
//# sourceMappingURL=language-urls.prop.js.map